import React from "react";
import { formatDateMonthYearShort } from "@utils/formatDate";
import { formatNumberDecimals } from "@utils/formatNumber";
import { Invoice } from "./InvoiceTableColumns";
import { usePartnerStore } from "@store/partnerStore";

interface InvoiceTableExpandContentProps {
  invoice: Invoice;
}

export const InvoiceTableExpandContent: React.FC<InvoiceTableExpandContentProps> = ({
  invoice,
}) => {
  const { currency } = usePartnerStore();

  if (!invoice.months || invoice.months.length === 0) {
    return (
      <div className="text-sm text-gray-500">No months available</div>
    );
  }

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Months</h4>
      <div className="space-y-2">
        {invoice.months.map((month, index) => (
          <div
            key={index}
            className="flex items-center justify-between py-2 px-3 bg-white rounded border border-gray-200"
          >
            <div className="text-sm font-medium text-gray-900">
              {formatDateMonthYearShort(month.month)}
            </div>
            <div className="text-sm font-medium text-gray-900">
              {formatNumberDecimals(month.amount)}
              {currency && (
                <span className="ml-1 text-gray-600">{currency}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

